import { useContext } from "react";
import { windowScaleContext } from "./windowScaleContext";

export const useWindowScale = () => {
  return useContext(windowScaleContext);
}
